export const EXTENSION_ID = 'ddaldkbafpjfhjloomcdphceflbfhkge';
export const MANAGER_MESSAGE_BUS = 'manager_message_bus';
